import { Navigate } from "react-router-dom";
import useAuth from "app/hooks/useAuth";
import { useTenantHost } from "app/tenant/TenantHostProvider";
import PublicHospitalProfile from "./PublicHospitalProfile";

const STAFF_HOME = "/dashboard/default";

/**
 * Tenant subdomains render the shared public profile for anonymous visitors.
 * Authenticated staff (and generic hosts such as app.cheritto.com) must land on
 * the staff dashboard — appsLaunchUrl is historically "/" for hospital apps.
 */
export default function PublicHospitalRoot() {
  const tenant = useTenantHost();
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={STAFF_HOME} replace />;
  }
  if (!tenant?.isTenantHost) {
    return <Navigate to={STAFF_HOME} replace />;
  }
  return <PublicHospitalProfile />;
}
